export default ({ user = "", ...overrides }) => ({
  eventType: null,
  location: null,
  radiusInMiles: { value: "0", label: "0 miles" },
  eventDescription: "",
  guests: null,
  layout: null,
  budget: null,
  start_date: null,
  end_date: null,
  start_time: "08:00",
  end_time: "18:00",
  userEmail: user,
  userName: "",
  userPhone: "",
  userCompany: "",
  styles: [],
  catering: {
    venue: false,
    external: false,
    self: false,
    full_bar: false,
    tea_coffee: false,
  },
  newsletter: false,
  isCorporate: undefined,
  isMultipleEvents: false,
  virtualEvents: false,
  isFlexible: false,
  isTOSAccepted: false,
  ...overrides,
});
